import React from 'react';
import { Link } from 'react-router-dom';
import { FiCheck, FiX } from 'react-icons/fi';
import SafeIcon from '../components/SafeIcon';
import PageHeader from '../components/shared/PageHeader';
import CtaSection from '../components/shared/CtaSection';

const Maintenance = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <PageHeader 
        title="Maintenance Plans" 
        subtitle="Protect your investment, reduce breakdowns, and save on energy bills with a NorthPeak Maintenance Plan."
        image="https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80&w=2000"
      />

      <section className="section-padding bg-bg">
        <div className="container-custom">
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            
            {/* Basic Plan */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex flex-col">
              <div className="p-8 text-center border-b border-gray-100">
                <h3 className="text-2xl font-bold text-gray-800 mb-2">Basic Care</h3>
                <div className="flex justify-center items-baseline gap-1 mb-4">
                  <span className="text-4xl font-black text-primary">$149</span>
                  <span className="text-muted">/year</span>
                </div>
                <p className="text-sm text-muted">Essential checkup for a single system.</p>
              </div>
              <div className="p-8 flex-grow">
                <ul className="space-y-4 mb-8">
                  <li className="flex items-start gap-3"><SafeIcon icon={FiCheck} className="text-green-500 mt-1" /> <span>1 Annual Tune-up (Heating OR Cooling)</span></li>
                  <li className="flex items-start gap-3"><SafeIcon icon={FiCheck} className="text-green-500 mt-1" /> <span>Basic safety inspection</span></li>
                  <li className="flex items-start gap-3"><SafeIcon icon={FiCheck} className="text-green-500 mt-1" /> <span>Filter replacement (standard 1")</span></li>
                  <li className="flex items-start gap-3 text-gray-400"><SafeIcon icon={FiX} className="mt-1" /> <span>Priority Scheduling</span></li>
                  <li className="flex items-start gap-3 text-gray-400"><SafeIcon icon={FiX} className="mt-1" /> <span>Discount on Repairs</span></li>
                </ul>
              </div>
              <div className="p-8 pt-0 mt-auto">
                <Link to="/contact" className="btn-secondary w-full">Sign Up</Link>
              </div>
            </div>

            {/* Comfort Plan (Popular) */}
            <div className="bg-white rounded-2xl shadow-xl border-2 border-secondary relative transform md:-translate-y-4 flex flex-col">
              <div className="absolute top-0 inset-x-0 bg-secondary text-white text-center py-1 text-sm font-bold uppercase tracking-wider">
                Most Popular
              </div>
              <div className="p-8 text-center border-b border-gray-100 mt-4">
                <h3 className="text-2xl font-bold text-gray-800 mb-2">Comfort Plan</h3>
                <div className="flex justify-center items-baseline gap-1 mb-4">
                  <span className="text-4xl font-black text-primary">$249</span>
                  <span className="text-muted">/year</span>
                </div>
                <p className="text-sm text-muted">Complete seasonal coverage for peace of mind.</p>
              </div>
              <div className="p-8 flex-grow">
                <ul className="space-y-4 mb-8">
                  <li className="flex items-start gap-3"><SafeIcon icon={FiCheck} className="text-green-500 mt-1" /> <strong>2 Annual Tune-ups (Heating AND Cooling)</strong></li>
                  <li className="flex items-start gap-3"><SafeIcon icon={FiCheck} className="text-green-500 mt-1" /> <span>Comprehensive system cleaning</span></li>
                  <li className="flex items-start gap-3"><SafeIcon icon={FiCheck} className="text-green-500 mt-1" /> <span>Filter replacement (standard 1")</span></li>
                  <li className="flex items-start gap-3"><SafeIcon icon={FiCheck} className="text-green-500 mt-1" /> <strong>Priority 48hr Scheduling</strong></li>
                  <li className="flex items-start gap-3"><SafeIcon icon={FiCheck} className="text-green-500 mt-1" /> <strong>10% Discount on Repairs</strong></li>
                </ul>
              </div>
              <div className="p-8 pt-0 mt-auto">
                <Link to="/contact" className="btn-primary w-full shadow-lg shadow-secondary/30">Sign Up</Link>
              </div>
            </div>

            {/* Premium Plan */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex flex-col">
              <div className="p-8 text-center border-b border-gray-100">
                <h3 className="text-2xl font-bold text-gray-800 mb-2">Premium Care</h3>
                <div className="flex justify-center items-baseline gap-1 mb-4">
                  <span className="text-4xl font-black text-primary">$399</span>
                  <span className="text-muted">/year</span>
                </div>
                <p className="text-sm text-muted">Ultimate protection and VIP service.</p>
              </div>
              <div className="p-8 flex-grow">
                <ul className="space-y-4 mb-8">
                  <li className="flex items-start gap-3"><SafeIcon icon={FiCheck} className="text-green-500 mt-1" /> <span>2 Annual Tune-ups (Heating AND Cooling)</span></li>
                  <li className="flex items-start gap-3"><SafeIcon icon={FiCheck} className="text-green-500 mt-1" /> <span>Humidifier/IAQ inspection included</span></li>
                  <li className="flex items-start gap-3"><SafeIcon icon={FiCheck} className="text-green-500 mt-1" /> <span>Specialty filter replacement included</span></li>
                  <li className="flex items-start gap-3"><SafeIcon icon={FiCheck} className="text-green-500 mt-1" /> <strong>Same-Day Priority Scheduling</strong></li>
                  <li className="flex items-start gap-3"><SafeIcon icon={FiCheck} className="text-green-500 mt-1" /> <strong>15% Discount on Repairs</strong></li>
                  <li className="flex items-start gap-3"><SafeIcon icon={FiCheck} className="text-green-500 mt-1" /> <strong>No After-Hours Fees</strong></li>
                </ul>
              </div>
              <div className="p-8 pt-0 mt-auto">
                <Link to="/contact" className="btn-secondary w-full">Sign Up</Link>
              </div>
            </div>

          </div>
        </div>
      </section>
      
      <CtaSection />
    </div>
  );
};

export default Maintenance;